import Map from "./components/map/map";
import Sidebar from "./components/sidebar/sidebar";
import "./App.css";
import Header from "./components/header/header";
import { DataProvider } from "./contexts/DataContext";
import { TimingProvider } from "./contexts/TimingContext";
import { MenuProvider } from "./contexts/MenuContext";
import { EDFDataProvider } from "./contexts/EDFDataContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://7bd84e5a90effb15173eacf6b2b6306b@o4506928951984128.ingest.us.sentry.io/4507573776154624",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", process.env.REACT_APP_BACKEND_URL],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enabled: process.env.NODE_ENV !== "development",
});

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <DataProvider>
        <EDFDataProvider>
          <TimingProvider>
            <MenuProvider>
              <div className="App">
                <Sidebar />
                <Header />
                <Map />
              </div>
            </MenuProvider>
          </TimingProvider>
        </EDFDataProvider>
      </DataProvider>
    </QueryClientProvider>
  );
}

export default App;
